import React, { useMemo } from "react";
import CustomTag from "./CustomTag";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import AlertTypeId from "src/consts/AlertTypeId";

interface RemoteStopLimitTagProps {
  binDto: PremierPlusBinDTO | null | undefined;
}

const RemoteStopLimitTag : React.FC<RemoteStopLimitTagProps> = ({ binDto }) => {

    const remoteStopTripped = useMemo (() => {
        return binDto?.activeAlerts?.some(alert => alert.alertTypeId === AlertTypeId.RemoteStop);
    }, [binDto]);

    return (
      <CustomTag
        label={remoteStopTripped ? "Remote stop NOT OK" : "Remote stop limit OK"}
        icon={remoteStopTripped ? <CloseCircleFilled /> : <CheckCircleFilled />}
        color={remoteStopTripped ? "red" : "green"}
      />
    );
  };
  
  export default RemoteStopLimitTag;
  